var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.62,
    height: 8.618,
    viewBox: "0 0 8.62 8.618",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_45617",
    "data-name": "Path 45617",
    d: "M.9,0,.98.011,4.3,3.3,7.621.02A.144.144,0,0,1,7.7,0c.095.01.748.762.891.863a.122.122,0,0,1,0,.153L5.312,4.3,8.6,7.62c.04.074.011.121-.032.181a9.975,9.975,0,0,1-.777.775.154.154,0,0,1-.188.015L4.318,5.311,1,8.6a.13.13,0,0,1-.086.014C.809,8.6.178,7.857.026,7.752c-.052-.065-.011-.139.039-.19L3.306,4.317.015,1A.13.13,0,0,1,0,.916,11.735,11.735,0,0,1,.9,0",
    transform: "translate(0.001 0)",
    fill: "red"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/cross_mark.94a8b8353ed6b04d0579f26a949e9a24.svg";
export { ForwardRef as ReactComponent };